// Sentinel `Error.cause` value used by `/test-error` and the
// `previewUpmsGlobalError` cookie to trigger an on-demand error for manually
// verifying error-page rendering. Checked in error.tsx / global-error.tsx to
// skip Datadog reporting for these intentionally-thrown test errors.
export const TEST_ERROR_CAUSE = 'pie-testing';
